<button
  *ngIf="visible"
  type="button"
  class="back-to-top-button"
  (click)="backToTop()"
  title="Return to top of page"
  aria-label="Return to top of page"
>
  <fa-icon [icon]="faChevronUp" aria-hidden="true"></fa-icon>
  <span aria-hidden="true">Back to top</span>
</button>
